import './style.scss';

function tabsRenderer($block) {

}

// Initialize dynamic block preview (editor).
if( window.acf ) {
	window.acf.addAction( 'render_block_preview/type=tabs', tabsRenderer );
}